import { connect } from 'react-redux'
import compose from 'lodash/flowRight'

import { RigipsStore } from 'redux/redux'
import { withRouter } from 'react-router-dom'
import withCompanyLogoMutation from './companyLogoMutation'
import withCompanyLogoQuery from './companyLogoQuery'

import SettingsLogoPage from './settingsLogoPage'

const mapStateToProps = (state: RigipsStore) => {
  const {
    auth: { authenticated },
  } = state

  return { authenticated }
}

const withConnect = connect(mapStateToProps)

export default compose(
  withConnect,
  withCompanyLogoMutation,
  withCompanyLogoQuery,
)(withRouter(SettingsLogoPage))
